<template>
  <div>
    <Form :label-width="80" inline>
      <FormItem label="公告名称">
        <Input v-model="searchValue.articleName" placeholder="请输入公告名称搜索" style="width:300px;"></Input>
      </FormItem>
      <FormItem label="项目简编">
        <Input v-model="searchValue.projectNumAbbr" style="width:100px;"></Input>
        <Button type="primary" style="margin-left:10px;" @click="searchArticles">搜索</Button>
      </FormItem>
    </Form>
    <Table style="margin-top:10px;" :columns="articleColumns" :data="articleList"></Table>
    <Page ref="page" :page-size="8" style="margin-top:10px;" :total="totalArticles" show-elevator show-total @on-change="changePage"></Page>
  </div>
</template>

<script>
// import axios from 'axios'
import ajax from '../lib/ajax'
import requestUrls from '../lib/requestUrls'

export default {
  name: 'articleChoose',
  data() {
    return {
      articleColumns: [
        {
          title: '公告名称',
          key: 'title'
        },
        {
          title: '项目简编',
          key: 'projectShort',
          width: 200
        },
        {
          title: '操作',
          align: 'center',
          width: 100,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.importArticle(params.row)
                  }
                }
              }, '选择'),
            ]);
          }
        }
      ],
      articleList: [],
      totalArticles: 0,
      searchValue: {
        articleName: '',
        projectNumAbbr: ''
      },
    }
  },
  created() {
    this.initArticles()
  },
  methods: {
    async initArticles() {
      let rep = await ajax.get(requestUrls.articles.getPaged, {
        params: {
          maxResultCount: 8,
          skipCount: 0,
          filter: 'a.ext2=="74166" and a.isDispaly == "true"',
          sorting: 'a.creationTime desc'
        }
      })
      if (rep.data.success) {
        this.articleList = rep.data.result.items
        this.totalArticles = rep.data.result.totalCount
      }
    },
    async getArticles(page, searchValue) {
      let searArticleName = searchValue.articleName ? ` and a.title.Contains("${searchValue.articleName}")` : ''
      let searNumAbbr = searchValue.projectNumAbbr ? ` and p.projectShort.Contains("${searchValue.projectNumAbbr}")` : ''
      let filter = 'a.ext2 == "74166" and a.isDispaly=="true"' + searArticleName + searNumAbbr
      let rep = await ajax.get(requestUrls.articles.getPaged, {
        params: {
          maxResultCount: 8,
          skipCount: (page - 1)*8,
          filter: filter,
          sorting: 'a.creationTime desc'
        }
      })
      if (rep.data.success) {
        this.articleList = rep.data.result.items
        this.totalArticles = rep.data.result.totalCount
        if (page === 1) {
          this.$refs.page.currentPage = 1
        }
      }
    },
    changePage(page) {
      this.getArticles(page, this.searchValue)
    },
    searchArticles() {
      this.getArticles(1, this.searchValue)
    },
    importArticle(article) {
      this.$emit('endImport', article)
    }
  }
}
</script>

<style lang="less" scoped>
</style>
